<template>
    <CalendarPrev
        v-bind="forwardedProps"
        :as="DsIconButton"
        icon="fa-solid fa-chevron-left"
        size="xs"
        tooltipText="Previous month"
    />
</template>

<script setup lang="ts">
import DsIconButton from '@/components/design-system/button/DsIconButton.vue';
import { reactiveOmit } from '@vueuse/core';
import type { CalendarPrevProps } from 'reka-ui';
import { CalendarPrev, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<CalendarPrevProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
